import type { PropsWithChildren } from 'react'

interface LegendContainerProps extends PropsWithChildren {
  className?: string
}

export function LegendContainer({
  children,
  className = '',
}: LegendContainerProps) {
  return (
    <div className={`flex items-center gap-6 ${className}`}>{children}</div>
  )
}

interface LegendItemProps extends PropsWithChildren {
  className?: string
}

export function LegendItem({ children, className = '' }: LegendItemProps) {
  return (
    <div className={`flex items-center gap-1 ${className}`}>{children}</div>
  )
}

interface ColorIndicatorProps {
  color: string
  className?: string
}

export function ColorIndicator({ color, className = '' }: ColorIndicatorProps) {
  return (
    <div
      className={`h-3 w-3 rounded-sm my-auto ${className}`}
      style={{ backgroundColor: color }}
    />
  )
}

interface LabelProps extends PropsWithChildren {
  className?: string
}

export function Label({ children, className = '' }: LabelProps) {
  return (
    <span
      className={`text-primary text-xs leading-normal my-auto ${className}`}
    >
      {children}
    </span>
  )
}
